import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [];
      // 待发放
      if (this.tabId == 1 && this.$units.pointAction('offline_81_8_btn6')) {
        columns.push({
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '结算周期',
          key: 'settlementDate',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          key: 'reportName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '税前合计（元）',
          key: 'totalIncome',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            const text = params.row.issueType == 3 ? params.row.requestAmount : params.row.totalIncome;
            return <span>{text || '-'}</span>;
          }
        },
        {
          title: '税后合计（元）',
          key: 'netIncome',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            const text = params.row.issueType == 3 ? params.row.requestAmount : params.row.netIncome;
            return <span>{text || '-'}</span>;
          }
        },
        {
          title: '风险单金额（元）',
          key: 'riskAmount',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            return <span>{params.row.riskAmount || '0'}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          align: 'center'
        }
      ]);
      this.columns = columns;
    }
  }
};
